import React from 'react'; 

const ErrorAlert = ({children}) => {
    return <div className="alert alert-danger" role="alert">{children}</div>;
}

export default ErrorAlert;
    